import { LanguageAvailable } from '@shared/services/language/models';

export const pageSEO = (title: string) => ({
  title: title,
  description: `Ceci est le ${title}`,
  url: 'http://url-de-la-page.mock/fake',
  twitter: {
    twitter_title: '',
    twitter_description: '',
    twitter_image: 'image pour twitter',
  },
  og: {
    og_title: '',
    og_description: '',
    og_image: 'image pour og',
    og_type: 'article',
  },
  gtmConfig: {
    event: 'page_view',
    page_type: `page_type pour ${title}`,
    page_cat1_name: `page_cat1_name pour ${title}`,
    page_cat2_name: `page_cat2_name pour ${title}`,
    page_cat3_name: `page_cat3_name pour ${title}`,
    checkout_step: undefined!,
    checkout_type: '',
    checkout_store: '',
    tunnel_referrer: '',
    group: '',
    description: '',
    context: '',
  },
});

interface PageBase {
  type: string;
  title: string;
  language: LanguageAvailable;
  headerId: string;
  headerSubMenuId?: string;
  footerId: string | null;
  isBreadcrumbOverlay: boolean;
  context?: { name: string; uuid: string };
}

export const pageBase = (p: PageBase) => ({
  type: p.type,
  config: {
    language: p.language,
    header: {
      id: p.headerId,
      ...(p.headerSubMenuId ? { subMenuId: p.headerSubMenuId } : {}),
    },
    footer: {
      id: p.footerId,
    },
    seo: pageSEO(p.title),
    ...(p.context ? { context: p.context } : {}),
    breadcrumb: {
      isOverlay: p.isBreadcrumbOverlay,
      items: [
        {
          title: '...',
          url: '/',
        },
        {
          title: p.title,
          url: '',
        },
      ],
    },
  },
});
